<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="73px"
    height="73px"
    viewBox="0 0 34 27"
    enable-background="new 0 0 34 27"
    xml:space="preserve"
  >
    <g>
      <rect x="12" y="9"  fill="white" width="10" height="1.4" />
      <rect x="12" y="12" fill="white" width="10" height="1.4" />
      <rect x="12" y="15" fill="white" width="10" height="1.4" />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'BurgerMenuIcon'
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

g {
  color: $primary;
}
</style>
